
import {
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
  IconButton,
  alpha,
  LinearProgress,
  useTheme,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Business as BusinessIcon
} from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { usePropertyInventory } from '../../../../hooks/usePropertyInventory';
import { useMediaQuery } from '@mui/system';
import { Step3ApartmentDetails } from './steps/Step3ApartmentDetails';
import { CreateApartmentsSummary } from './steps/CreateApartmentsSummary';

interface CreateApartmentsProps {
  complexId?: string;
}
const CreateApartments = () => {
  const { currentStep } = usePropertyInventory();
  const navigate = useNavigate();
  const { id } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const steps = [
    'Crear Apartamento',
    'Resumen Final'
  ];

  return (
    <Box sx={{ backgroundColor: 'white', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ 
        p: 3, 
        borderBottom: '1px solid #E0E0E0',
        backgroundColor: 'white',
        mb: 3 
      }}>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <IconButton
              sx={{ 
                mr: 2,
                backgroundColor: alpha('#4DB6AC', 0.1),
                '&:hover': {
                  backgroundColor: alpha('#4DB6AC', 0.2),
                }
              }}
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon sx={{ color: '#4DB6AC' }} />
            </IconButton>
            <BusinessIcon sx={{ mr: 2, color: '#4DB6AC' }} />
            <Typography variant="h5" component="div" fontWeight="bold" color="#2E7D7A">
              Crear Apartamentos
            </Typography>
          </Box>

          {/* Stepper adaptativo */}
          <Stepper 
            activeStep={currentStep} 
            orientation={isMobile ? "vertical" : "horizontal"} 
            alternativeLabel={!isMobile}
            sx={{ mb: 2 }}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel
                  sx={{
                    '& .MuiStepLabel-label': {
                      color: '#666',
                      fontSize: '0.875rem'
                    },
                    '& .MuiStepLabel-label.Mui-active': {
                      color: '#2E7D7A',
                      fontWeight: 'bold'
                    },
                    '& .MuiStepLabel-label.Mui-completed': {
                      color: '#4DB6AC'
                    }
                  }}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>

          {/* Barra de progreso */}
          <LinearProgress 
            variant="determinate" 
            value={((currentStep + 1) / steps.length) * 100}
            sx={{
              height: 6,
              borderRadius: 3,
              backgroundColor: alpha('#4DB6AC', 0.2),
              '& .MuiLinearProgress-bar': {
                backgroundColor: '#4DB6AC',
                borderRadius: 3,
              }
            }}
          />
        </Box>
      </Box>

      {/* Contenido del paso actual */}
      <Box>
        <StepContent
          complexId={id || ''}
        />
      </Box>
    </Box>
  );
};
const StepContent: React.FC<CreateApartmentsProps> = ({ complexId }) => {
  const { currentStep } = usePropertyInventory();

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <Step3ApartmentDetails
          complexId={complexId || ''}
        />;
      case 1:
        return <CreateApartmentsSummary 
          complexId={complexId || ''}
        />;
      default:
        return <Step3ApartmentDetails
          complexId={complexId || ''}
        />;
    }
  };

  return renderStep();
};

export default CreateApartments;